import { render } from 'preact'
import { App } from './components/App.jsx'
import ActionCard from './components/ActionCard.jsx'
import './index.css'
import './i18n'
import { createContext } from 'preact'
import fomService from './services/fomService.js'
import dataProviderService from './services/dataProviderService.js'
import { track } from './services/analytics.js'

const urlParams = new URLSearchParams(window.location.search)
const name = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'name'))
const playbookId = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'playbookid'))
const hideScore = urlParams.has([...urlParams.keys()].find(key => key.toLowerCase() === 'hidescore'))
const email = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'email'))
const theme = urlParams.get([...urlParams.keys()].find(key => key.toLowerCase() === 'theme'))

export const AppContext = createContext()
let context = {}

;(async () => {
  document.documentElement.classList.toggle(
    'dark',
    theme === 'dark' || (!theme && window.matchMedia('(prefers-color-scheme: dark)').matches),
  )
  try {
    if (playbookId) {
      // WebPlay mode (action card and settings are loaded from the playbook)
      track('ac_requested', {
        playbookId: playbookId,
      })
      const webPlayInfo = await fomService.getWebPlayInfo(playbookId)
      context = { ...webPlayInfo, playbookId }
      const dataProvider = await dataProviderService.getByWebPlay(playbookId, webPlayInfo, hideScore, email)
      await window.initActionCards(dataProvider)
      render(
        <AppContext.Provider value={context}>
          <App />
        </AppContext.Provider>,
        document.getElementById('app'),
      )
    } else {
      // Standalone mode (action card is loaded from the specified file)
      const fileName = name || 'demo'
      track('ac_requested', {
        name: fileName,
      })
      const dataProvider = await dataProviderService.getByName(fileName, hideScore)
      await window.initActionCards(dataProvider)
      render(<ActionCard></ActionCard>, document.getElementById('app'))
    }
  } catch (error) {
    console.error('Failed to initialize the app:', error)
  }
})()
